import React, { useState } from "react";

import { IAnimal } from "../../modules/animals/interface";
import { useNotification } from "../../hooks/useNotification";
import { useTranslate } from "../../hooks/useTranslate";
import {
  Button,
  Chip,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useItemModal } from "../../hooks/useModal";
import { AnimalItem } from "../AnimalItem";

interface Props {
  animals: IAnimal[];
  onSubmit: (name: string, animals: string[]) => Promise<void>;
}

export const CreateFlock = ({ animals, onSubmit, ...rest }: Props) => {
  const modalItem = useItemModal();
  const { translate } = useTranslate();
  const { errorNotification } = useNotification();

  const [name, setName] = useState<string | null>();

  // const [openList, setOpenList] = useState(false);
  const [selectedAnimals, setSelectedAnimals] = useState<string[]>([]);

  const handleOnChecked = (animalId: string, checked: boolean) => {
    if (checked) {
      setSelectedAnimals((oldState) => [...oldState, animalId]);
      return;
    }

    const selectedAnimalsFiltered = selectedAnimals.filter(
      (item) => item !== animalId
    );
    setSelectedAnimals(selectedAnimalsFiltered);
  };

  const submit = async () => {
    if (!name) {
      errorNotification(translate("animals.name_batch_required"));
      return;
    }

    // if (selectedAnimals.length === 0) {
    //   errorNotification(translate("animals.min_1_animal_required"));
    //   return;
    // }

    modalItem.close();
    await onSubmit?.(name, selectedAnimals);
  };

  return (
    <>
      <Stack spacing={2}>
        <TextField
          fullWidth
          value={name ?? ""}
          onChange={(event) => {
            setName(event.target.value);
          }}
          color="primary"
          variant="standard"
          placeholder={translate("global.placeholder_name")}
        />
        <Stack spacing={2} mt={3}>
          <Stack direction="row" spacing={1} justifyContent="space-between">
            <Typography color="primary">
              {translate("animals.select_animal")}
            </Typography>
            <Chip label={animals.length} />
          </Stack>
          <Stack spacing={1}>
            {animals.map((animal) => (
              <Paper
                elevation={0}
                sx={{ bgcolor: "grey.50", p: 1 }}
                key={animal.id}
              >
                <AnimalItem
                  animal={animal}
                  checked={selectedAnimals.includes(animal.id)}
                  onCheckChange={handleOnChecked}
                />
              </Paper>
            ))}
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button
              fullWidth
              onClick={() => {
                modalItem.close();
              }}
            >
              {translate("global.cancel")}
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={submit}
              disabled={
                (name?.length ?? 0) === 0 || selectedAnimals.length === 0
              }
            >
              {translate("animals.label_btn_new_flock")}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
